import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageRequestSearch } from '../../../models/api-dam/image/image-request.model';
import { ImageService } from '../../../services/api-dam/image/image.service';
import { LOADINGIMAGE } from '../../../utils/config/image-settings';
import { FALSE, TRUE } from '../../../utils/config/const';
import { UtilsService } from '../../../services/utils-folder/utils.service';


@Component({
  selector: 'app-load-image-from-dam',
  templateUrl: './load-image-from-dam.component.html',
  styleUrls: ['./load-image-from-dam.component.css']
})
export class LoadImageFromDamComponent implements OnInit {

  @Input() title: string;
  @Input() idImages: any[];
  @Input() multiple: boolean;
  @Output() choiceButton = new EventEmitter<string>();

  private DEFAULT_title = "Scelta immagine";
  private DIMPAGE_default: number = 40;
  private NUMEROPAGINA_default: number = 0;
  public loading: boolean = true;
  public loadingImage: string = LOADINGIMAGE;
  public imagesList: any = [];
  public imagesMapList: any = {};
  public dimPagina: number = this.DIMPAGE_default;
  public numeroPagina: number = this.NUMEROPAGINA_default;
  searchFilterForm: FormGroup;
  busyGettingData: boolean = false;


  /* Infinite scroll params */
  throttle = 300;
  scrollDistance = 2;


  selectImages: any = {}
  selectImagesObj: any = {}

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private imageService: ImageService,
    private utilsService: UtilsService
  ) {
    this.searchFilterForm = this.fb.group({
      searchFilterField: ''
    });
  }

  ngOnInit(): void {
    this.title = this.DEFAULT_title;
    if (this.multiple == null || typeof this.multiple == typeof undefined) {
      this.multiple = false;
    }
    this.initSelected();
    this.search();
  }


  initSelected() {
    this.selectImages = {};
    if (this.idImages != null && typeof this.idImages != typeof undefined) {
      for (let obj of this.idImages) {
        let id = parseInt(obj);
        this.selectImages[id] = true;
      }
    }
  }

  /**
   * Seleziona le immagini
   * @param id 
   */
  selectImage(id) {
    if (this.multiple === TRUE) {
      //Selezione multipla
      if (!this.selectImages.hasOwnProperty(id)) {
        this.selectImages[id] = true;
      } else {
        this.selectImages[id] = !this.selectImages[id];
      }

      //Aggiorno il valore nella vista che sto visualizzando
      if (this.imagesMapList.hasOwnProperty(id)) {
        let pos = this.imagesMapList[id];
        this.imagesList[pos].selected = this.selectImages[id];
        if (this.imagesList[pos].selected == TRUE) {
          this.selectImagesObj[id] = this.imagesList[pos];
        }
      }

    } else {
      //Selezione singola
      if (!this.selectImages.hasOwnProperty(id)) {
        this.resetSelectedImages();
        this.selectImages = {}
        this.selectImages[id] = true;
        let pos = this.imagesMapList[id];
        this.imagesList[pos].selected = true;

        this.selectImagesObj = {}
        this.selectImagesObj[id] = this.imagesList[pos];

      } else {
        this.selectImages = {}
        this.selectImagesObj = {}
        let pos = this.imagesMapList[id];
        this.imagesList[pos].selected = false;
      }

    }
  }

  resetSelectedImages() {
    for (let key in this.selectImages) {
      if (this.imagesMapList.hasOwnProperty(key)) {
        let pos = this.imagesMapList[key];
        this.imagesList[pos].selected = false;
      }
    }
  }


  getSelectedImages() {
    let images = [];
    for (let key in this.selectImages) {
      if (this.selectImages[key] == TRUE) {
        images.push(this.selectImagesObj[key]);
      }
    }
    return images;
  }




  /**
   * Click sulla lente per la ricerca
   */
  clickSearch() {
    this.resetListImage();
    this.search();
  }

  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let imageRequestSearch = new ImageRequestSearch();
    imageRequestSearch.name = this.searchFilterForm.controls['searchFilterField'].value;
    imageRequestSearch.pageNumber = this.numeroPagina;
    imageRequestSearch.pageSize = this.dimPagina;
    return imageRequestSearch;
  }

  /**
   * Ricerca generica
   */
  search() {
    this.loading = true;
    let imageRequestSearch = this.getFilter();
    this.imageService.search(imageRequestSearch).subscribe(
      (response) => {
        this.loading = false;
        this.setListImage(response);
        this.busyGettingData = false
      },
      (error: HttpErrorResponse) => {
        this.loading = false;
        console.log(error);
        this.busyGettingData = false
      }
    );
  }

  /**
   * Setta le informazioni della response 
   * */
  setListImage(response) {
    if (response != null && typeof response != typeof undefined) {
      if (response.hasOwnProperty("data")) {
        let data = response.data
        for (let i = 0; i < data.length; i++) {
          this.insertImage(data[i], i);
        }
      }
    }
  }


  insertImage(imageObj, pos) {
    let idImage = imageObj.id;
    this.imagesMapList[idImage] = pos;

    //Controllo se è selezionata
    imageObj["selected"] = false;
    if (this.selectImages.hasOwnProperty(idImage)) {
      imageObj.selected = this.selectImages[idImage];
      if (imageObj.selected == TRUE) {
        this.selectImagesObj[imageObj.id] = imageObj;
      }
    }


    if (imageObj.published === FALSE) {
      imageObj.url = LOADINGIMAGE;
    }
    this.imagesList.push(imageObj);
    if (imageObj.published === FALSE) {
      this.downloadImage(idImage);
    }

  }

  /**
   * Reset dei filtri di ricerca
   */
  resetListImage() {
    this.imagesList = [];
    this.imagesMapList = {};
    this.dimPagina = this.DIMPAGE_default;
    this.numeroPagina = this.NUMEROPAGINA_default;
  }

  /**
   * Carica immagine non pubblica
   * @param idImage 
   */
  downloadImage(idImage) {
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imagesList[this.imagesMapList[idImage]].url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse) => {
        this.imagesList[this.imagesMapList[idImage]].url = "/assets/images/no-image-icon.png";
      }
    );
  }







  clickConfirm() {
    let listImages = this.getSelectedImages();
    this.activeModal.close({
      images: listImages
    });
  }

  clickCancel() {
    this.activeModal.close('CLOSE');
  }

  onScrollDown() {
    if (this.busyGettingData) {
      return
    } else {
      this.busyGettingData = true
      this.numeroPagina++;
      this.search();
    }
  }

}
